module.exports = __webpack_public_path__ + "static/media/dollar.37739bd5.svg";